import { registryModule } from '@boost-sd/components-registry/registry';
import type { Dict } from '@boost-sd/core-js';
import { DEFAULT_LOCALE } from '@constants/locale';
import {
  addParamsLocale,
  buildInfoWithRequestId,
  buildRequestIdForProducts,
  buildRequestIdMoreInformation,
  getCurrentPage,
} from '@utils';

const { recommendUrl } = window.boostSDAppConfig?.api || {};
const API_URL = recommendUrl || 'https://staging.bc-solutions.net/discovery/recommend';

export const RecommendationAPI = registryModule('RecommendationAPI', {
  get: async (params: Dict, body: Dict) => {
    const currentPage = getCurrentPage();

    params = {
      ...params,
      locale: DEFAULT_LOCALE,
      event_type: 'init',
      pg: currentPage,
    };
    params = addParamsLocale(params);
    const queryParams = new URLSearchParams(params);

    body = {
      ...body,
      locale: DEFAULT_LOCALE,
      pg: currentPage,
    };

    body = addParamsLocale(body);

    const response = await fetch(`${API_URL}?${queryParams}`, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      return Promise.reject(response);
    }

    // save requestId
    const requestId = response.headers.get('X-Request-ID') || '';
    const dataResponse = await response.json();
    buildRequestIdForProducts(requestId, dataResponse.products, 'recommendation', true);
    const moreInformation = {
      a: 'recommend',
      wid: params.wid,
      rt: params.recommendationType,
    };
    buildRequestIdMoreInformation(requestId, moreInformation, true);
    buildInfoWithRequestId(requestId, {
      query_string: '', // query string ở recommendation not need tracking
      action: 'recommend',
    });

    return dataResponse;
  },
});
